export default __webpack_public_path__ + "e784628ab85ea4b5d61c0502e198287a.svg";